import { Button, Typography } from '@material-ui/core';
import { createStyles, StyledComponentProps, withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import * as React from 'react';
import { EntityImage } from '../../comps/EntityImage';
import { ISupplier } from '../../main/entities';
import { transl } from '../../main/transl';

const styles = createStyles({
	whole: {
		display: 'block',
		width: '120px',
		marginBottom: 10,
		padding: 0,
		alignItems: 'stretch',
		textAlign: 'center',
		backgroundColor: '#2C395B',
		border: '2px solid #333333',
		borderColor: 'transparent',
		filter: 'grayscale(50%)',
		'&:hover': {
			boxShadow: '0px 0 11px rgba(0,0,0,0.9)',
			filter: 'none',
			backgroundColor: '#2C395B',
		},
		textTransform: 'none',
	},
	selected: {
		backgroundColor: '#102888',
		borderColor: 'transparent',
		filter: 'none',
		'&:hover': {
			backgroundColor: '#102888',
		},
	},
	top: {
	},
	bottom: {
		marginTop: 5,
		padding: 2,
		backgroundColor: '#02151310',
	},
	supplierImage: {
		alignSelf: 'center',
		marginTop: 5,
		maxHeight: 120,
		maxWidth: '100%',
	},
	supplierName: {
		padding: 5,
		alignSelf: 'center',
		fontSize: '0.8rem',
		color: '#EEEEEE',
	},
	items: {
		borderTop: 'solid 1px #EEEEEE',
		color: '#EEEEEE',
	},
	priceText: {
		color: '#FF7866',
	},
});

export interface IMySupplier extends ISupplier {
	nPricedItems: number
	nUnpricedItems: number
	priceSum: number
	priceText: string
	imageLink: string
}

interface IMiniCartProps {
	supplier: IMySupplier
	isSelected: boolean
	isOnly: boolean
	onClick(id: number) : void
}

@observer class _MiniCart extends React.Component<IMiniCartProps & StyledComponentProps> {
	_onClick = () => this.props.onClick(this.props.supplier.id)

	render() {
		const classes = this.props.classes || {};
		const {supplier, isSelected, isOnly} = this.props;

		return <Button
			className={classNames(classes.whole, {[classes.selected as any]: isSelected || isOnly})}
			disabled={isOnly}
			onClick={this._onClick}>
			<div className={classes.top}>{
				supplier.imageLink
					?
					<EntityImage entity={supplier} className={classes.supplierImage}/>
					:
					<Typography display="inline" variant="h6" className={classes.supplierName}>{supplier.name}</Typography>
			}</div>
			<div className={classes.bottom}>{
				!supplier.nPricedItems && !supplier.nUnpricedItems
					?
					<div className={classes.items}>{transl('minicart.noItems')}</div>
					:
					!supplier.nPricedItems
						?
						<div className={classes.items}>{transl('minicart.items', supplier.nUnpricedItems)}</div>
						:
						!supplier.nUnpricedItems
							?
							<div>
								<div className={classes.items}>{transl('minicart.items', supplier.nPricedItems)}</div>
								<div className={classes.priceText}>{supplier.priceText}</div>
							</div>
							:
							<div>
								<div className={classes.items}>{transl('minicart.items', supplier.nPricedItems)}</div>
								<div className={classes.priceText}>{supplier.priceText}</div>
								<div className={classes.items}>{transl('minicart.unpricedItems', supplier.nUnpricedItems)}</div>
							</div>
			}</div>
		</Button>;
	}
}

export const MiniCart = withStyles(styles)(_MiniCart);
